// React binding for reviewSession.js, for review screens that are a single
// component rather than a route family (the RMS letter review). The assessment
// report pages are covered by ReviewSessionTracker instead — use one or the
// other, never both, or the second mount would end the first one's sitting.

import { useEffect } from 'react';
import { startReviewTracking, stopReviewTracking, noteReviewCompleted } from './reviewSession';

/**
 * Track review sittings on the RMS letter review screen. Starts once the
 * letter identity has resolved (letterType is null while the page works out
 * which letter it is showing) and ends on unmount or identity change; the
 * engine handles visibility and idle on its own.
 *
 * Returns noteCompleted for the page's finish action, so a sitting in which
 * the letter reached full approval ends as 'completed'.
 */
export function useRmsLetterReviewSession({ patientRecordId, letterType, pathway }) {
  useEffect(() => {
    if (!patientRecordId || !letterType) return undefined;
    startReviewTracking('rms_letter', { patientRecordId, letterType, pathway });
    return () => stopReviewTracking();
  }, [patientRecordId, letterType, pathway]);

  return { noteCompleted: noteReviewCompleted };
}
